export const popularEmailProviders = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'hotmail.co.uk',
  'aol.com',
  'live.com',
  'outlook.com',
  'googlemail',
  'msn.com'
]

export const supportedLocales = {
  'en-GB': {
    nativeName: 'English (UK)',
    englishName: 'English (UK)'
  },
  'en-AU': {
    nativeName: 'English (Australia)',
    englishName: 'English (Australia)'
  },
  'en-CA': {
    nativeName: 'English (Canada)',
    englishName: 'English (Canada)'
  },
  'en-IE': {
    nativeName: 'English (Ireland)',
    englishName: 'English (Ireland)'
  },
  'en-IN': {
    nativeName: 'English (India)',
    englishName: 'English (India)'
  },
  'en-US': {
    nativeName: 'English (US)',
    englishName: 'English (US)'
  },
  'fr-CA': {
    nativeName: 'French (CA)',
    englishName: 'French (CA)'
  }
}
